import {NgModule} from '@angular/core';
import {MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {APP_DATE_FORMATS} from './app.constants';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatInputModule} from '@angular/material/input';
import {MatTableModule} from '@angular/material/table';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatExpansionModule} from '@angular/material/expansion';
import {DateAdapter, MAT_DATE_FORMATS, MatRippleModule} from '@angular/material/core';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatRadioModule} from '@angular/material/radio';
import {MatSortModule} from '@angular/material/sort';
import {CommonModule} from '@angular/common';
import {MatDividerModule} from '@angular/material/divider';
import {MatTabsModule} from '@angular/material/tabs';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatListModule} from '@angular/material/list';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatBadgeModule} from '@angular/material/badge';
import {ObserversModule} from '@angular/cdk/observers';

@NgModule({
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatCardModule,
    MatInputModule,
    MatTableModule,
    MatMenuModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatDividerModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMomentDateModule,
    MatPaginatorModule,
    MatExpansionModule,
    MatRadioModule,
    MatRippleModule,
    MatGridListModule,
    MatSortModule,
    CommonModule,
    MatTabsModule,
    MatAutocompleteModule,
    MatListModule,
    MatButtonToggleModule,
    MatBadgeModule,
    ObserversModule
  ],
  exports: [
    MatToolbarModule,
    MatButtonModule,
    MatCardModule,
    MatInputModule,
    MatTableModule,
    MatMenuModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatDividerModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatSelectModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatExpansionModule,
    MatRadioModule,
    MatRippleModule,
    MatGridListModule,
    MatSortModule,
    MatTabsModule,
    MatAutocompleteModule,
    MatListModule,
    MatButtonToggleModule,
    MatBadgeModule,
    ObserversModule
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter
    },
    {provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: {useUtc: true}},
    {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS}
  ]
})
export class CustomMaterialModule {
}
